<template>
  <div>
    <Breadcrumbs page_title="livestreaming" :items="breadcrumbs" />
    <template>
      <!-- STATE 1: Has data -->
      <v-card class="mx-3 my-5 rounded-lg" v-if="hasData">
        <v-container fluid>
          <v-row class="d-flex">
            <v-col v-for="item in sessions" :key="item.liveSessionID" cols="12" lg="6" md="6" sm="12" class="border">
              <v-list class="pt-2 pb-0">
                <v-list-item-group>
                  <v-list-item class="pa-0" @click="goToDetail(item)">
                    <!-- Thumbnail -->
                    <v-col cols="3" class="pr-2 pl-2">
                      <v-img v-if="item.imageLink" :src="item.imageLink" class="live-thumb rounded-lg"></v-img>
                      <div v-else class="live-thumb-placeholder rounded-lg d-flex align-center justify-center">
                        <v-icon size="40" color="#A6CC39">mdi-broadcast</v-icon>
                      </div>
                    </v-col>

                    <!-- Content -->
                    <v-col cols="7">
                      <v-list-item-content style="color: #424242">
                        <v-list-item-title
                          style="font-size: 16px; font-weight: bold; white-space: normal; line-height: 1.4">
                          {{ item.title }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="mt-1" style="color: #4fb14e">
                          <v-icon small color="#4fb14e">mdi-calendar</v-icon>
                          {{ formatDate(item.scheduleDate) }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="mt-1">
                          <v-icon small>mdi-clock-outline</v-icon>
                          {{ formatTime(item.startTime) }} - {{ formatTime(item.endTime) }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-col>

                    <!-- Status badge -->
                    <v-col cols="2" class="d-flex align-center justify-center pa-0">
                      <v-chip small label class="font-weight-bold" :class="statusClass(item.status)">
                        <v-icon x-small left>
                          {{ statusIcon(item.status) }}
                        </v-icon>
                        {{ statusLabel(item.status) }}
                      </v-chip>
                    </v-col>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
              <div class="border-bottom-line"></div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>

      <!-- STATE 2: Loading skeleton -->
      <v-card class="mx-3 my-5 rounded-lg" v-else-if="loading">
        <v-row class="mx-3 my-5">
          <v-col cols="6" v-for="n in 4" :key="n">
            <v-skeleton-loader class="mx-auto" max-height="160" type="list-item-avatar-two-line"></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-card>

      <!-- STATE 3: Empty -->
      <v-card class="noarticle mx-3 my-5 rounded-lg d-flex justify-center" v-else>
        <div class="text-center nodata">{{ $t("nolivestreaming") }}</div>
      </v-card>
    </template>
  </div>
</template>

<script>
export default {
  name: "LiveStreaming",
  data() {
    return {
      sessions: [],
      loading: true,
      hasData: false,
      breadcrumbs: [
        {
          text: "livestreaming",
        },
      ],
    };
  },
  mounted() {
    this.getFavourite();
    this.getNotificationCount();
    this.getSessions();
  },
  methods: {
    async getSessions() {
      const companyId = localStorage.getItem("companyID");
      const userId = Number.parseInt(localStorage.getItem("UserID"));
      const res = await this.$axios.get(
        `${this.web_url}LiveSession/GetAllSessionMobile`,
        { params: { companyId, userId } }
      );
      if (res.data.data && res.data.data.length > 0) {
        this.sessions = res.data.data.map((v, i) => ({
          ...v,
          no: i + 1,
          status: Number.parseInt(v.status),
        }));
        this.loading = false;
        this.hasData = true;
      } else {
        this.loading = false;
        this.hasData = false;
      }
    },
    statusLabel(status) {
      const s = Number.parseInt(status);
      if (s === 0 || s === 1) return "Scheduled";
      if (s === 2) return "LIVE";
      if (s === 3) return "Ended";
      return "Ended";
    },
    statusClass(status) {
      const s = Number.parseInt(status);
      if (s === 0 || s === 1) return "badge--scheduled";
      if (s === 2) return "badge--live";
      if (s === 3) return "badge--ended";
      return "badge--ended";
    },
    statusIcon(status) {
      const s = Number.parseInt(status);
      if (s === 2) return "mdi-circle";
      if (s === 0 || s === 1) return "mdi-clock-outline";
      return "mdi-check-circle-outline";
    },
    goToDetail(item) {
      this.$router.push({
        path: "/live/" + item.liveSessionID,
        query: { sessionId: item.liveSessionID },
      });
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      const dt = new Date(dateStr);
      const day = dt.getDate();
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const month = months[dt.getMonth()];
      const year = dt.getFullYear();
      return `${day} ${month} ${year}`;
    },
    formatTime(dateStr) {
      if (!dateStr) return '';
      const dt = new Date(dateStr);
      return dt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
    },
  },
};
</script>

<style scoped>
.live-thumb {
  height: 90px;
  width: 100%;
  object-fit: cover;
}

.live-thumb-placeholder {
  height: 90px;
  background-color: #f5f5f5;
}

.border-bottom-line {
  border-bottom: 1px solid #e0e0e0;
  margin: 0 12px;
}

.noarticle {
  height: 200px;
  align-items: center;
}

.nodata {
  color: #a4a4a4;
  font-size: 20px !important;
}

.badge--scheduled {
  background-color: #1976d2 !important;
  color: #fff !important;
}

.badge--live {
  background-color: #e53935 !important;
  color: #000 !important;
}

.badge--ended {
  background-color: #9e9e9e !important;
  color: #000 !important;
}
</style>
